// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".background-grey[data-v-b916fa94]{background-color:#f7f7f7;box-shadow:0 2px 10px rgba(0,0,0,.15)}.qr-container[data-v-b916fa94]{align-items:center;display:flex;flex-direction:column}.qr-text[data-v-b916fa94]{color:#333;font-size:16px;margin-top:16px;padding:0 10px;text-align:center}.btn-custom[data-v-b916fa94]{color:#212121!important;letter-spacing:0;text-transform:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
